export const weekText = ['日', '一', '二', '三', '四', '五', '六'];
export const monthText = '月';
export const yearText = '年';
